import { SharedModule } from './../shared/shared.module';
import { MenuModule } from './menu/menu.module';
import { HeaderModule } from './header/header.module';
import { FooterModule } from './footer/footer.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsumidorService } from '../restrito/consumidor/shared/index';

@NgModule({
  imports: [
    CommonModule,
    FooterModule,
    HeaderModule,
    MenuModule,
    SharedModule.forRoot()
  ],
  providers: [
    ConsumidorService
  ],
  declarations: [],
  exports: [FooterModule,
    HeaderModule,
    MenuModule]
})
export class SharedLayoutModule { }



// WEBPACK FOOTER //
// ./src/app/shared-layout/shared-layout.module.ts